import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FileItem} from '@aposin/ng-aquila/file-uploader';
import {Subject, Observable} from 'rxjs';
import {UploadFileStatus} from '../../enums/upload-file-status';
import {ApiDeleteUploadFileObjectFormatted, ApiUploadObjectFormatted} from '../../interfaces/api-object-formatted';
import {FormFileUpload} from '../../interfaces/forms/file-upload';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private _uploadSubject: Subject<ApiUploadObjectFormatted> = new Subject();
  private _deleteFilesSubject: Subject<ApiDeleteUploadFileObjectFormatted> = new Subject();

  constructor() {}

  uploadFiles(files: FileItem[], fileInputData: FormFileUpload): Observable<unknown> {
    return new Observable((uploadResolver) => {
      this._uploadSubject.next({files, fileInputData, uploadResolver});
    });
  }

  getUploadRequest(): Observable<ApiUploadObjectFormatted> {
    return this._uploadSubject.asObservable();
  }

  deleteFile(deletedFile: FileItem, fileInputData: FormFileUpload): Observable<unknown> {
    return new Observable((uploadResolver) => {
      this._deleteFilesSubject.next({
        deletedFile,
        fileInputData,
        uploadResolver,
      });
    });
  }

  getDeleteFile(): Observable<ApiDeleteUploadFileObjectFormatted> {
    return this._deleteFilesSubject.asObservable();
  }

  getDeleteFileObserver() {
    return this._deleteFilesSubject.observers;
  }

  setUploadState(status: UploadFileStatus, arrFiles: FileItem[], index: number = -1) {
    const arr = index >= 0 ? [arrFiles[index]] : arrFiles;
    arr.forEach((el) => {
      try {
        if (el[status]) {
          el[status]();
        }
      } catch (error) {
        console.warn('uploadStatus error', status, error);
      }
    });
  }

  setUploadComplete({files, fileInputData}: {files: FileItem[]; fileInputData: FormFileUpload}, formGroup: FormGroup) {
    formGroup.get(fileInputData.name)?.setErrors({isUploading: false});
    this.setUploadState(UploadFileStatus.COMPLETE, files);
  }
}
